'use client';

import { SponsorsSection } from '@/components/molecules';
import { SponsorsListSkeleton } from '@/components/organisms/skeletons/SponsorsListSkeleton';
import { useSponsors } from '@/hooks/hooks';

export const SponsorsList = ({ teamLeagueUuid }: { teamLeagueUuid: string }) => {
	const { data: sponsorsInfo, isLoading: isLoadingSponsors } = useSponsors(teamLeagueUuid);

	if (isLoadingSponsors) {
		return <SponsorsListSkeleton />;
	}

	if (!sponsorsInfo || sponsorsInfo?.data.length === 0) {
		return null;
	}

	return (
		<div className="flex w-[320px] flex-col gap-6 pt-4 md:pt-6">
			{sponsorsInfo.data.map((sponsors) => (
				<SponsorsSection key={sponsors.sponsorLevelId} sponsorLevel={sponsors} />
			))}
		</div>
	);
};
